<script>
	import AppBase from '../../../QtEngine3/FirebaseAdminComponents/src/AppBase.svelte'

	import TicketPlugin from "./TicketPlugin.svelte"
	import UserDetailsPlugin from "./UserDetailsPlugin.svelte"

	import TournamentType from "../../../QtEngine3/Common/SharedFiles/Constants/JsFiles/TournamentType.js" 

	const firebaseConfig = {
		apiKey: "AIzaSyBdFY0Bbl7xU4RktivI15TCGdbQwfyeXUg",
		//authDomain: "cafe-dash-45858.firebaseapp.com",
		//authDomain: "cafe-dash-45858.web.app",
		authDomain: window.location.hostname, // Support all authorized domains from console.cloud.google.com
		databaseURL: "https://cafe-dash-45858-default-rtdb.firebaseio.com",
		projectId: "cafe-dash-45858",
		storageBucket: "cafe-dash-45858.appspot.com",
		messagingSenderId: "238626980951",
		appId: "1:238626980951:web:6ec9520ce0920b5872cf12",
		measurementId: "G-BNSH5F80G5"
	}
	
	// For Firebase JS SDK v7.20.0 and later, measurementId is optional
	const qaFirebaseConfig = {
		apiKey: "AIzaSyD95lPcXugawqHrOBAmAzfdIM6rgFjDJF4",
		//authDomain: "qa-cafe-dash.firebaseapp.com",
		authDomain: window.location.hostname, // Support all authorized domains from console.cloud.google.com
		databaseURL: "https://qa-cafe-dash-default-rtdb.firebaseio.com",
		projectId: "qa-cafe-dash",
		storageBucket: "qa-cafe-dash.appspot.com",
		messagingSenderId: "877162909655",
		appId: "1:877162909655:web:c27d63f6876a70248b8592",
		measurementId: "G-B6JEJ47VCV"
	};	

	const tournamentTypes = [
		TournamentType.CompleteLevel, TournamentType.StrokeCat, TournamentType.CollectLikes, TournamentType.EarnMedals, TournamentType.EliteV2, TournamentType.Holiday
	]

    function putInQuotes(str) {
		// string params should be in quotes ("zzz")
		return '"' + str + '"'
	}
	
	const numberPattern = "^\\d+$"
	const doublePattern = "^\\d*\.?\\d+$"
	const arrayPattern = "^\\[(\\d+,)*\\d+\\]$"
    const dateRangePattern = '^"\\d+\\.\\d+ - \\d+\\.\\d+"$'
	const booleanPattern = [false, true]
	const experimentAvailableParams = {
        adBattlePassesEnabled: [booleanPattern, false],
		adBattlePassTargetEventDates: [dateRangePattern, putInQuotes("15.03 - 20.04")],
		adBattlePassTargetEventName: ["^\"\\w*\"$", putInQuotes("")],
		adBattlePassTicketPriceVariant: [numberPattern, 0],
        adEnabled: [booleanPattern, false],
        battlePassesEnabled: [booleanPattern, false],
        cleaningWithoutCleanerEnabled: [booleanPattern, false],
        dailyBundleEnabled: [booleanPattern, false],
        endlessOfferEnabled: [booleanPattern, false],
        goldBankBundlesEnabled: [booleanPattern, false],
        hasLuckyBoxesInBank: [booleanPattern, false],
        interstitialAdEnabled: [booleanPattern, false],
        kittenTuningEnabled: [booleanPattern, false],
        levelCoffeeMachineEnabled: [booleanPattern, false],
        levelsGroup: [[1, 2, 3], 1],
        loyalBoosterAdUnitEnabled: [booleanPattern, false],
        magicKeysEnabled: [booleanPattern, false],
        mainTargetResumePrice: [arrayPattern, "[1,2,3]"],
        newbiePackVariant: [numberPattern, 0],
        newEconomyEnabled: [booleanPattern, false],
        questMapEnabled: [booleanPattern, false],
        skipAdBundleEnabled: [booleanPattern, false],
        skipAdsOfferEnabled: [booleanPattern, false],
		overrideDeliveryTime: [booleanPattern, false],
		overridedUniversalDeliveryTime: [numberPattern, 300000],
		adCouponsEnabled: [booleanPattern, false],
		doubleInterstitialRate: [numberPattern, 0]
	} 

</script>

<AppBase projectName="Cafe Dash"
	{firebaseConfig} 
	ticketPlugin={TicketPlugin} 
    userDetailsPlugin={UserDetailsPlugin} 
    {experimentAvailableParams} 
	{tournamentTypes}
    googleplayConsoleId="7671276898701304735"
/> 
